<template>
  <div>
    <AppSection
      id="test-connectivity"
      type="section"
      :title="$getConst.pages.scopeSettingDashboard.monitoring_jobs"
      :is-section-loading="is_loading"
    >

      <b-row class="justify-content-center py-5">

        <template v-for="option in options">
          <b-col v-if="option.is_shown" xl="3" lg="4" md="4" sm="6" class="pb-4">
            <b-overlay :show="option.isLoading || option.success !== null" class="h-100" opacity="1">
              <AppPageOptionBox
                v-if="!hasWritePermission"
                @onClick="onSubmit(option)" :text="option.text" :icon="option.icon"/>
            </b-overlay>
          </b-col>
        </template>

      </b-row>

    </AppSection>
  </div>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../../../components/common/utils/AppPageOptionBox";
  import {getOneScope} from "../../../../api/scopes.api";
  export default {
    name: "jobs",
    components: {AppPageOptionBox, AppSection},
    props: {
      scope_id: null
    },
    data() {
      return {
        hasWritePermission: !this.hasAnyOfPermissions(
          [
            this.$getConst.permissions.readScope, this.$getConst.permissions.readScopeMailCredentials
          ]
        ),
        scope: null,
        is_loading: false
      }
    },
    computed: {
      options() {
        if (this.scope && !this.is_loading) {
          return [
            {destination: "JOBS", text: this.$t(this.$getConst.pages.connectivity_test.last_jobs), icon: this.$getConst.svgIcons.jobs_logs, isLoading: false, success: null, is_shown: true},
            {destination: "PENDING", text: this.$t(this.$getConst.pages.connectivity_test.pending_jobs), icon: this.$getConst.svgIcons.jobs_logs, isLoading: false, success: null, is_shown: true},
            {destination: "FAILED", text: this.$t(this.$getConst.pages.connectivity_test.failed_jobs), icon: this.$getConst.svgIcons.jobs_logs, isLoading: false, success: null, is_shown: true},
            {destination: "FAILED_LAUNCHED", text: this.$t(this.$getConst.pages.connectivity_test.failed_jobs_launched), icon: this.$getConst.svgIcons.jobs_logs, isLoading: false, success: null, is_shown: true},
          ]
        }
      }
    },
    methods: {
      onSubmit(option) {
        option.isLoading = true;
        switch (option.destination) {
          case "PENDING":
            this.pendingJobs();
            break;
          case "FAILED":
            this.failedJobs();
            break;
          case "JOBS":
            this.monitoringJobs();
            break;
          case "FAILED_LAUNCHED":
            this.failedJobsLaunched();
            break;
          default:
            break;
        }
      },
      monitoringJobs(){
        this.$router.push({name: this.$getConst.routesNames.administration.lastJobs});
      },
      pendingJobs(){
        this.$router.push({name: this.$getConst.routesNames.administration.pendingJobs});
      },
      failedJobs(){
        this.$router.push({name: this.$getConst.routesNames.administration.failedJobs});
      },
      failedJobsLaunched(){
        this.$router.push({name: this.$getConst.routesNames.administration.failedJobsLaunched});
      },
      getScope() {
        this.is_loading = true;
        getOneScope(this.scope_id).then(
          response => {
            this.scope = response.data;
            this.is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.is_loading = false;
          }
        )
      }
    },
    created() {
      this.getScope();
    }
  }
</script>

<style scoped>
  .b-overlay {
    margin: 0 !important;
  }
</style>
